import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function AboutHero() {
  return <section data-section-id="225048" id="featured-guide" className="relative min-h-[600px] h-[80vh] flex items-center bg-background overflow-hidden dark">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/smart_kitchen_lighting.png)]" />
      
      {}
      <div className="absolute inset-0 bg-black/60" />

      {}
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <h1 className="font-default font-bold text-5xl md:text-6xl lg:text-[72px] text-white leading-[1.1] mb-6 tracking-tight">
            Master Your <span className="text-primary">Home</span>
          </h1>
          
          <p className="font-default font-light text-xl md:text-2xl text-white/90 mb-10 max-w-2xl leading-relaxed">
            Experience the art of simple living with automated routines that wake your home as gently as the sunrise.
          </p>
          
          <Button asChild className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 ease-out text-lg h-14 px-10 shadow-xl">
            <Link to="#">Explore Automations</Link>
          </Button>
        </div>
      </div>

      {}
     
    </section>;
}